import { FC } from 'react'
import { IconProps } from '@chakra-ui/react'

import { UserCheckmark } from 'components/icons'

type Props = IconProps

const PublicAgentsPermissions: FC<Props> = (props) => {
  return <UserCheckmark {...props} />
}

const PublicAgentsPermissionsExports = {
  PublicAgentsPermissions,
}

export default PublicAgentsPermissionsExports
